import React, { ReactNode } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export interface CryoboxTableProps {
  children: ReactNode;
}

function CryoboxTable({ children }: CryoboxTableProps) {
  return (
    <TableContainer
      sx={{
        border: 1,
        borderColor: 'divider',
        overflow: 'auto',
      }}
    >
      <Table aria-label="cryobox table">
        <TableHead>
          <TableRow
            sx={{
              bgcolor: 'grey.50',
              '& th': {
                fontWeight: 700,
                color: 'text.secondary',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                borderBottom: 1,
                borderBottomColor: 'divider',
                py: 1.5,
                whiteSpace: 'nowrap',
              },
            }}
          >
            <TableCell align="left" sx={{ minWidth: 150 }}>
              Serial No.
            </TableCell>
            <TableCell align="center">Type</TableCell>
            <TableCell align="center">Freezer</TableCell>
            <TableCell align="center">Shelf</TableCell>
            <TableCell align="center">Rack</TableCell>
            <TableCell align="center">Position</TableCell>
            <TableCell align="center">Slot</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>

        <TableBody
          sx={{
            '& tr:last-of-type td': {
              borderBottom: 0,
            },
            '& td': {
              py: 1.75,
              verticalAlign: 'middle',
            },
          }}
        >
          {children}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CryoboxTable;
